import { BaseService } from "mrb/core";
import { LoadioAlbumFileStreamApiRouteService } from "common/services";

class LoadioAlbumFileStreamService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new LoadioAlbumFileStreamApiRouteService());
    }

    get(id, params, abortSignal = null) {
        const url = this.routeService.get(id, params);
        return this.apiClient.get(url, null, abortSignal);
    }
}

export default LoadioAlbumFileStreamService;
